import { render } from "./recentCompanies.vue?vue&type=template&id=d836a88e"
import script from "./recentCompanies.vue?vue&type=script&lang=js"
export * from "./recentCompanies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__